import styled from 'styled-components';

const ShowItemWrapper = styled.a`
  display: inline-block;
  width: 200px;
  height: 100px;
  line-height: 100px;
  border-radius: 12px;
  text-align: center;
  background-color: #49b1f5;
  outline: none;
  span {
    color: #fff;
  }
`;

export {ShowItemWrapper};
